import { useContext, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { message, Grid, Modal, Button } from 'antd';
import styled from 'styled-components';
import { isLocaleEnglish } from 'utils/languageUtils';
import { sessionStorageService } from 'utils/SessionStorageService';

import { HomeContext } from 'contexts/home/context';
import { GreetingSection, SwiperBanner, MakerTab, LhomeContent, BannerCarousel } from './components';
import { type IconCardProps } from 'components/card';
import NewClaimIcon from 'assets/images/home/new-claim.svg';
import ShieldIcon from 'assets/images/home/shield.svg';
import CalendarIcon from 'assets/images/home/calendar.svg';
import ClaimRecordsIcon from 'assets/images/home/claim-records.svg';
import LiBanner from 'assets/images/home/life-insurance-banner.svg';
import { Spinner } from 'components';
import Close from 'assets/images/liHome/close.svg';
import { useLocation } from 'react-router-dom';
import { useLifeHome, useLifeHomeNews, useGetPromPopUp, usePostPromPopUp } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { formatNews, formatPolicy } from 'utils/liHome';
const { useBreakpoint } = Grid;
interface ContainerProps {
  size?: string;
}
const HomePageContainer = styled.div<ContainerProps>`
  // margin: ${(props) => (props.size == 'lg' ? `0` : `0 16px`)};
  font-family: 'Roboto400';
`;

interface LocationState {
  fileNotFound: boolean;
}

interface GetPromDetail {
  popupGroupId: string;
  popupId: string;
  messageEn: string;
  messageTc: string;
  targetAction: string;
  linkTc: string;
  linkEn: string;
}

interface GetPromPopUpProps {
  promotionDontShowAgain: string;
  mfaDontShowAgain?: string;
  promotionBannerPosition: number;
  promotionWEB: GetPromDetail;
  promotionIOS: GetPromDetail;
  promotionAndroid: GetPromDetail;
  mfaWEB?: GetPromDetail;
  mfaIOS?: GetPromDetail;
  mfaAndroid?: GetPromDetail;
}

function HomePage() {
  const { t, i18n } = useTranslation();
  const { state, showTips } = useContext(HomeContext);
  const { userAccess } = state;
  const location = useLocation();
  const [isFileNotFound, setIsFileNotFound] = useState((location.state as LocationState)?.fileNotFound || false);
  const iconCardItems: IconCardProps[] = [];
  const isEnglish = isLocaleEnglish(i18n.language);
  const { sm, lg, xs } = useBreakpoint();
  const { ready, token, tokenParsed } = useKeycloakReady();
  const [randoms, setRandoms] = useState(Math.random());
  const [randoms1, setRandoms1] = useState(Math.random());
  const [startLoading, setStartLoading] = useState<boolean>(false);
  const {
    data: LifeHomeData,
    shouldFetch: shouldFetchLifeHome,
    error: lifeHomeError,
  } = useLifeHome(token ?? '', 'useLifehome' + randoms, 'Y');
  const {
    data: BannerData,
    shouldFetch: shouldFetchBanner,
    error: bannerError,
  } = useLifeHomeNews(token ?? '', 'useLifeHomeNews' + randoms);
  const {
    alertsNum3,
    policyHolderFirstName,
    alertsPaymentNum,
    myPolicies,
    alertsPolicyUpdateNum,
    alertsClaimUpdateNum,
  } = LifeHomeData ?? {};
  const { data: PromData, shouldFetch: shouldfetchProm } = useGetPromPopUp('useGetPromPopUp', token ?? '');

  // useEffect(() => {
  //   if (LifeHomeData && BannerData && PromData) {
  //     setStartLoading(false);
  //   }
  // }, [LifeHomeData, BannerData, PromData]);
  useEffect(() => {
    if (lifeHomeError) {
      setStartLoading(false);
    }
    if (bannerError) {
      setStartLoading(false);
    }
  }, [lifeHomeError, bannerError]);

  useEffect(() => {
    setStartLoading(true);
    setRandoms(Math.random());
    shouldFetchLifeHome(ready); // 使用 shouldFetchLifeHome
    shouldFetchBanner(ready);
  }, [ready, shouldFetchLifeHome, tokenParsed, shouldFetchBanner]);
  const formattedNews = useMemo(
    () => formatNews(BannerData, isEnglish, token ?? '', BannerData?.length),
    [BannerData, isEnglish, token],
  );
  const formattedPolicy = formatPolicy(myPolicies, isEnglish);
  if (userAccess?.panel) {
    iconCardItems.push({
      to: '/network-doctors',
      icon: ShieldIcon,
      title: t('home.findNetworkDoctorTitle'),
      description: t('home.findNetworkDoctorDescription'),
    });
  }

  if (userAccess?.teladoc) {
    iconCardItems.push({
      to: '/teladoc-booking',
      icon: CalendarIcon,
      title: t('home.bookOnlineDoctorTitle'),
      description: t('home.bookOnlineDesc'),
    });
  }

  if (userAccess?.submitClaim) {
    iconCardItems.push({
      to: '/claims/new',
      icon: NewClaimIcon,
      title: t('home.fileANewClaimTitle'),
      description: t('home.fileANewClaimDescription'),
    });
  }

  iconCardItems.push({
    to: '/claims',
    icon: ClaimRecordsIcon,
    title: t('home.checkClaimRecords'),
    description: t('home.checkClaimRecordsDescription'),
  });

  useEffect(() => {
    if (isFileNotFound) {
      message.error(t('common.error.fileNotFound'));
      setIsFileNotFound(false);
    }
  }, [isFileNotFound, t]);

  const [showProm, setShowProm] = useState<boolean>(false);
  const [promPop, setPromPop] = useState<string>(sessionStorageService.get('promPop') || '');
  const [promAction, setPromAction] = useState<string>('');
  const [promData, setPromData] = useState<GetPromPopUpProps | null>();
  const [promNum, setPromNum] = useState<number>();
  const { shouldFetch: shouldfetchPromPost } = usePostPromPopUp(
    'usePostPromPopUp' + randoms1,
    token ?? '',
    promData?.promotionWEB?.popupGroupId ?? '',
    promData?.promotionWEB?.popupId ?? '',
    'PROMO',
    promAction,
  );

  const handleConfirm = () => {
    setPromAction('PURCHASE');
    setShowProm(false);
    // setPromNum(promData?.promotionBannerPosition);
    window.open(i18n.language == 'en' ? promData?.promotionWEB.linkEn : promData?.promotionWEB.linkTc, '_blank');
  };
  // const handleCancel = () => {
  //   console.log('点击了取消按钮');
  //   setPromAction('DONTSHOW');
  //   setShowProm(false);
  // };
  const handleClose = () => {
    // console.log('点击了关闭按钮');
    // setPromAction('CLOSE');
    // setShowProm(false);
    setPromAction('CONFIRM');
    setShowProm(false);
    setPromNum(promData?.promotionBannerPosition);
  };
  useEffect(() => {
    if (!promPop) {
      shouldfetchProm(true);
    }
  }, [promPop, shouldfetchProm]);
  useEffect(() => {
    if (PromData) {
      setPromData(PromData);
      shouldfetchProm(false);
      // if (PromData.promotionDontShowAgain == 'Y') {
      // setPromPop('true');
      // sessionStorageService.set('promPop', 'true');
      // }
    }
  }, [PromData, shouldfetchProm]);
  useEffect(() => {
    if (promAction) {
      setRandoms1(Math.random());
      shouldfetchPromPost(true);
    }
  }, [promAction, shouldfetchPromPost]);
  useEffect(() => {
    if (!showTips) {
      if (promData?.promotionDontShowAgain == 'Y') {
        setShowProm(true);
        setPromPop('true');
        sessionStorageService.set('promPop', 'true');
      } else {
        setShowProm(false);
      }
      setStartLoading(false);
    }
  }, [showTips, promData]);
  useEffect(() => {
    return () => {
      setPromData(null);
    };
  }, []);
  return (
    <HomePageContainer size={lg ? 'lg' : ''}>
      <div
        style={{
          position: 'relative',
        }}
      >
        <div
          style={{
            width: '100%',
            minHeight: '406px',
            paddingBottom: '46px',
            background: `url(${LiBanner}) no-repeat center center/cover`,
            position: 'relative',
          }}
        >
          {startLoading && (
            <div
              style={{
                width: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                zIndex: 999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Spinner />
            </div>
          )}
          <div
            style={{
              background: 'rgba(32, 37, 43, 0.6)',
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
            }}
          ></div>
          <GreetingSection alertsNum={alertsNum3} policyHolderFirstName={policyHolderFirstName} />
          {!sm
            ? !!formattedNews && <BannerCarousel news={formattedNews} num={promNum} />
            : !!formattedNews && <SwiperBanner news={formattedNews} num={promNum} />}
          <MakerTab
            alerts={{
              alert1: alertsPaymentNum,
              alert2: alertsPolicyUpdateNum,
              alert3: alertsClaimUpdateNum,
            }}
          ></MakerTab>
        </div>
        <LhomeContent myPolicies={formattedPolicy} policyBak={myPolicies}></LhomeContent>
      </div>
      <Modal
        open={showProm}
        onCancel={handleClose}
        className="e-notice-modal home-life"
        width={xs ? 'calc(100% - 32px)' : '510px'}
        closeIcon={<img src={Close} />}
        footer={[
          // <Button key="cancel" onClick={handleCancel}>
          //   {t('common.dontshow')}
          // </Button>,
          <Button
            key="submit"
            type="primary"
            style={{
              border: '2px solid #c21b17 ',
              color: '#fff',
            }}
            onClick={handleConfirm}
          >
            {t('life.home.purchase')}
          </Button>,
        ]}
      >
        <div>
          <div
            className="prom-content"
            dangerouslySetInnerHTML={{
              __html: isEnglish ? promData?.promotionWEB?.messageEn ?? '' : promData?.promotionWEB?.messageTc ?? '',
              // __html:
              //   "<p class='bold'>限時優惠！🎉</p>  <p>使用會員號「NEWS2506」購買<span class='bold'>單次旅遊計劃</span>或<span class='bold black'>家居保險</span>可享7折優惠！</p><p>經 GenBRAVO 人壽版面首頁點擊相關優惠連結，即轉到 Bravo 網站購買！</p>",
            }}
          />
          {/* <Title level={5} className={`red-font ${lg ? 'font-size26' : 'font-size22'}`}>
            {isEnglish ? promData?.promotionWEB?.messageEn : promData?.promotionWEB?.messageTc}
          </Title> */}
          {/* <Text className={`${lg ? 'font-size22' : 'font-size17'}`}>{t('life.policies.confirmGreenDesc')}</Text> */}
        </div>
      </Modal>
    </HomePageContainer>
  );
}

export default HomePage;
